var map = {
	"./alfaromeo.png": "cb2e",
	"./alphatauri.png": "7e63",
	"./alpine.png": "7813",
	"./astonmartin.png": "d58a",
	"./ferrari.png": "2ae8",
	"./haas.png": "0797",
	"./mclaren.png": "4c69",
	"./mercedes.png": "1075",
	"./rb.png": "5c85",
	"./redbull.png": "c386",
	"./stake.png": "b48a",
	"./williams.png": "ca3c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6d4";